import(/* webpackMode: "eager" */ "/vercel/path1/app/vocab/diagnostic/page.tsx");
